module.exports = __webpack_public_path__ + "static/img/border-6.6a1ba446.png";